import React from "react";

import { Redirect } from "react-router-dom";

import { useProfile } from "src/utils/customHook";

interface ApprovedGuardProps {
	children: any;
}

const ApprovedGuard: React.FC<ApprovedGuardProps> = ({ children }) => {
	const profile = useProfile();

	if (!profile?.isApproved) {
		return <Redirect to="/portfolio" />;
	}

	return children;
};

export default ApprovedGuard;
